module.exports = __webpack_public_path__ + "static/media/cenprot-web-site.6d17f233.png";